import { render, staticRenderFns } from "./ai-answer.vue?vue&type=template&id=55f097e6&scoped=true&"
import script from "./ai-answer.vue?vue&type=script&lang=js&"
export * from "./ai-answer.vue?vue&type=script&lang=js&"
import style0 from "./ai-answer.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./ai-answer.vue?vue&type=style&index=1&id=55f097e6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f097e6",
  null
  
)

export default component.exports